<div
  class="sidebar-backdrop"
  *ngIf="navOpen"
  aria-hidden="true"
  (click)="closeNav()"
></div>

<aside
  class="sidebar-drawer"
  [class.sidebar-drawer--open]="navOpen"
  [attr.aria-hidden]="!navOpen"
  aria-label="Navigation"
>
  <div class="sidebar-drawer__header">
    <img
      src="assets/images/custom/logo-healthexam.svg"
      alt="Health Exam"
      class="sidebar-drawer__logo"
    />
    <button
      type="button"
      class="sidebar-drawer__close"
      aria-label="Close navigation"
      (click)="closeNav()"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M2.5 5.75h11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
        <path d="M2.5 10.25h6.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <nav class="sidebar-drawer__nav">
    <ng-container *ngFor="let item of menuItems">
      <a
        *ngIf="!item.hasExternalLink"
        class="sidebar-drawer__link"
        routerLink="{{ item.link }}"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="closeNav()"
      >
        <img
          *ngIf="item.iconUrl"
          [src]="isCurrentRoute(item.link) ? item.activeIconUrl : item.iconUrl"
          alt=""
          width="18"
          height="18"
        />
        <span>{{ item.label }}</span>
      </a>
      <button
        *ngIf="item.hasExternalLink"
        type="button"
        class="sidebar-drawer__link"
        (click)="menuItemClicked(item); closeNav()"
      >
        <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" width="18" height="18" />
        <span>{{ item.label }}</span>
      </button>
    </ng-container>

    <button
      *ngIf="isGlobalAdmin"
      type="button"
      class="sidebar-drawer__link"
      (click)="openSettingsApp(); closeNav()"
    >
      <img src="assets/images/custom/sidebar/settings.svg" alt="" width="18" height="18" />
      <span>Settings</span>
    </button>
  </nav>

  <div class="sidebar-drawer__footer">
    <a
      class="sidebar-drawer__link"
      routerLink="/my-apps"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeNav()"
    >
      <span class="sidebar-drawer__link-icon">
        <img
          [src]="isCurrentRoute('/my-apps')
            ? 'assets/images/custom/sidebar/all-apps-active.svg'
            : 'assets/images/custom/sidebar/all-apps.svg'"
          alt=""
          width="18"
          height="18"
        />
      </span>
      <span>My Apps</span>
    </a>

    <button
      type="button"
      class="sidebar-drawer__user"
      aria-label="Account menu"
      [attr.aria-expanded]="showUserPopup"
      (click)="toggleUserPopup($event)"
    >
      <span class="user-avatar-trigger">
        <span class="user-avatar-trigger__initials">{{ currentUserInitials }}</span>
        <span class="user-avatar-trigger__status" aria-hidden="true"></span>
      </span>
      <span class="sidebar-drawer__user-details">
        <span class="sidebar-drawer__user-name">{{ currentUserName || 'Account' }}</span>
        <span class="sidebar-drawer__user-org" *ngIf="currentCompanyName">{{ currentCompanyName }}</span>
      </span>
    </button>
  </div>
</aside>

<div class="left-menu" *ngIf="!navOpen">
  <ngx-simplebar class="h-100" #componentRef>
    <div class="h-100 sidebar-menu">
      <div class="h-100 d-flex flex-column justify-content-between align-items-left">
        <ul>
          <li class="logo-menu-item">
            <button
              type="button"
              class="sidebar-logo-link"
              aria-label="Open navigation"
              [attr.aria-expanded]="navOpen"
              (click)="toggleNav($event)"
            >
              <img
                src="assets/images/custom/healthexam-mark.png"
                alt="Health Exam"
                class="sidebar-logo-mark"
                width="36"
                height="36"
              />
            </button>
          </li>
          <ng-container *ngFor="let item of menuItems">
            <li>
              <a
                *ngIf="!item.hasExternalLink"
                class="menu-link"
                routerLink="{{ item.link }}"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <img
                  *ngIf="item.iconUrl"
                  [src]="isCurrentRoute(item.link) ? item.activeIconUrl : item.iconUrl"
                  alt=""
                  width="18"
                  height="18"
                >
                <span class="menu-label"> {{ item.label }}</span>
              </a>
              <a *ngIf="item.hasExternalLink" class="menu-link" (click)="menuItemClicked(item)" role="button">
                <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" width="18" height="18">
                <span class="menu-label"> {{ item.label }}</span>
              </a>
            </li>
          </ng-container>
        </ul>
        <ul *ngIf="isGlobalAdmin">
          <li>
            <a class="menu-link" href="javascript:void(0)" (click)="openSettingsApp()">
              <img [src]="'assets/images/custom/sidebar/settings.svg'" alt="" width="18" height="18">
              <span class="menu-label"> Settings </span>
            </a>
          </li>
        </ul>
        <ul class="sidebar-bottom-actions">
          <li class="my-apps-menu-item">
            <a
              class="my-apps-trigger"
              routerLink="/my-apps"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              aria-label="My Apps"
              title="My Apps"
            >
              <img
                [src]="isCurrentRoute('/my-apps')
                  ? 'assets/images/custom/sidebar/all-apps-active.svg'
                  : 'assets/images/custom/sidebar/all-apps.svg'"
                alt=""
                width="18"
              >
            </a>
          </li>
          <li class="user-menu-item">
            <button
              type="button"
              class="user-menu-trigger"
              aria-label="Account menu"
              [attr.aria-expanded]="showUserPopup"
              (click)="toggleUserPopup($event)"
            >
              <span class="user-avatar-trigger">
                <span class="user-avatar-trigger__initials">{{ currentUserInitials }}</span>
                <span class="user-avatar-trigger__status" aria-hidden="true"></span>
              </span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </ngx-simplebar>
</div>

<div
  class="user-popup account-menu-popup"
  *ngIf="showUserPopup"
  [class.account-menu-popup--drawer]="navOpen"
  role="menu"
  aria-label="Account menu"
  (click)="$event.stopPropagation()"
>
  <div class="account-menu-profile">
    <div class="account-menu-avatar-wrap">
      <div class="account-menu-avatar">{{ currentUserInitials }}</div>
      <span class="account-menu-status-dot" aria-hidden="true"></span>
    </div>
    <div class="account-menu-details">
      <div class="account-menu-name">{{ currentUserName }}</div>
      <div class="account-menu-email" *ngIf="currentUserEmail">{{ currentUserEmail }}</div>
      <span class="account-menu-org-badge" *ngIf="currentCompanyName">{{ currentCompanyName }}</span>
    </div>
  </div>

  <div class="account-menu-divider" aria-hidden="true"></div>

  <div class="account-menu-actions">
    <button
      *ngIf="showCompanySwitch"
      type="button"
      role="menuitem"
      class="account-menu-action"
      (click)="gotoSelectCompanyPage()"
    >
      <i class="fa-light fa-building account-menu-action__icon"></i>
      <span>Switch organization</span>
    </button>
    <button
      type="button"
      role="menuitem"
      class="account-menu-action account-menu-action--signout"
      [disabled]="loggingOut"
      (click)="logout()"
    >
      <i class="fa-light fa-arrow-right-from-bracket account-menu-action__icon"></i>
      <span>{{ loggingOut ? 'Signing out...' : 'Sign out' }}</span>
    </button>
  </div>
</div>
